import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";
import { getBookingCalendarCellId } from "@ryde/shared";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookingExpanded } from "./rejected-bookings-expanded";
import { RejectedBookingsInsideBookingRow } from "./rejected-bookings-inside-bookings-row";

export const RejectedBookingsInsideBookingTable: FC = () => {
  const { conflicts } = useContext(BulkPreviewStepConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingExpanded>
      <ExpandedTable dataE2E="rejected-bookings-inside-bookings">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("booking.bulk.passengerId")}</TableCell>
              <TableCell>{t("booking.bulk.passengerFullName")}</TableCell>
              <TableCell>{t("booking.bulk.insideTheBooking")}</TableCell>
              <TableCell>{t("booking.bulk.date")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map((conflictRow, i) => (
              <RejectedBookingsInsideBookingRow
                key={`${getBookingCalendarCellId(conflictRow.passengerId as number, conflictRow.date)}_${i}`}
                conflictRow={conflictRow}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingExpanded>
  );
};
